import axiosDocumentIns from '@/services/axios/axiosDocumentos'

export default class DocumentoService {
  static async getFormularioComponentAnexos(ticketId, componenteId) {
    return axiosDocumentIns.get(`tickets/${ticketId}/elementos/${componenteId}/anexos`).then(res => res.data.data)
  }

  static async getTicketMensagensAnexos(ticketId) {
    return axiosDocumentIns.get(`tickets/${ticketId}/mensagens/anexos`).then(res => res.data.data)
  }

  static async getLogoEmpresa(logoId) {
    if (!logoId) return null
    try {
      return axiosDocumentIns.get(`logos-empresas/${logoId}`).then(res => res.data.data.uri)
    } catch {
      return null
    }
  }
}
